// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Instagram: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g fill="currentColor">
	<path d="M30.55,0H9.46C4.26,0,0,4.26,0,9.45v21.09C0,35.75,4.26,40,9.46,40h21.09c5.21,0,9.45-4.25,9.45-9.46V9.45
		C40,4.26,35.75,0,30.55,0z M20,32.1c-6.5,0-11.81-5.13-12.09-11.56L7.9,20l0.01-0.54C8.19,13.03,13.5,7.9,20,7.9
		c6.68,0,12.1,5.42,12.1,12.1C32.1,26.68,26.68,32.1,20,32.1z M33.09,10.36c-1.39,0-2.51-1.12-2.51-2.51c0-1.38,1.12-2.51,2.51-2.51
		c1.38,0,2.51,1.13,2.51,2.51C35.59,9.24,34.47,10.36,33.09,10.36z"/>
	<path d="M20,11.66c-4.45,0-8.09,3.49-8.33,7.89L11.66,20l0.01,0.46c0.24,4.39,3.88,7.88,8.33,7.88c4.61,0,8.34-3.74,8.34-8.34
		C28.34,15.39,24.61,11.66,20,11.66z"/>
</g>
</svg>;
};

export default React.memo(Instagram);
